import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Grid,
  DialogTitle,
  Divider,
  Tooltip,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  Skeleton,
  Stack,
  Chip,
} from "@mui/material";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from "dayjs";
import DatePicker from "../../../../components/DatePicker/DatePicker";
import AxiosInstance from "../../../AxiosInstance";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import "./style.css";
import "../../../../styles/fullCalendarTodayIndicator.css";
import WhiteButton from "../../../../components/Button/WhiteButton";
import BlueButton from "../../../../components/Button/BlueButton";
import InputText from "../../../../components/InputFields/InputText";
import CustomerModal from "../../Quotes/CustomerModal";
import showToast from "../../../../components/Toast/Toster";
import moment from "moment";
import { useUserTimezoneFormatter } from "../../../../components/UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import { handleAuth } from "../../../../components/Login/Auth";
import { getItem } from "../../../../utils/storage";
import { parseLocalDate } from "../../../../utils/dateUtils";
import { formatUSPhone } from "../../../../utils/usFormat";
import { EditIcon, LoaderComponent } from "../../../../components/Icon/Index";
import {
  JobberStatusBadge,
  getJobberStatusTone,
  getVisitAppointmentStatusTone,
  getCustomerContractListStatusTone,
} from "../../../../components/MuiTable/index.jsx";
import { useAdminDarkMode } from "../../../../contexts/AdminDarkModeContext";

const CustomEvent = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [clickTimeout, setClickTimeout] = useState(null);
  const [pendingClickEvent, setPendingClickEvent] = useState(null);
  const [customerMessageOpen, setCustomerMessageOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateTimestamp, setSelectedDateTimestamp] = useState(null);
  const [customerMessage, setCustomerMessage] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const [isPropertyModalOpen, setIsPropertyModalOpen] = useState(false);
  const [TimeStamp, setTimeStamp] = useState(false);

  const [formikValues, setFormikValues] = useState({
    CustomerId: "",
    LocationId: "",
    TimeStamp: "",
  });
  const [customerData, setCustomerData] = useState([]);
  const [isSavingMessage, setIsSavingMessage] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [existingMessages, setExistingMessages] = useState([]);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [isEditingMessage, setIsEditingMessage] = useState(false);
  const [editMessageText, setEditMessageText] = useState("");
  const [editEventDate, setEditEventDate] = useState(null);
  const [isUpdatingMessage, setIsUpdatingMessage] = useState(false);
  const [isDeletingMessage, setIsDeletingMessage] = useState(false);
  const [dateFormat, setDateFormat] = useState("MM/DD/YYYY");
  // Timezone from the authenticated user's profile. Drives FullCalendar's
  // `timeZone` prop so the "today" highlight and event placement match
  // what the user has configured rather than the browser's local zone.
  const [userTimezone, setUserTimezone] = useState("America/New_York");
  const [currentView, setCurrentView] = useState("dayGridMonth");
  const [mobileSelectedDate, setMobileSelectedDate] = useState(() => new Date());
  const [mobileDatePickerOpen, setMobileDatePickerOpen] = useState(false);
  const baseUrl = import.meta.env.VITE_BASE_API;
  const theme = useTheme();
  const isMobileModal = useMediaQuery(theme.breakpoints.down("sm"));
  const { darkMode: adminDark } = useAdminDarkMode();
  const shellDark = adminDark || theme.palette.mode === "dark";
  const sched = React.useMemo(() => {
    const dark = shellDark;
    return {
      titleBg: dark ? "#0f2844" : "#063164",
      /** Title bar is always a dark surface — keep text/icons light in admin light + dark */
      titleFg: "#ffffff",
      titleFgMuted: "rgba(255,255,255,0.9)",
      titleCloseHoverBg: "rgba(255,255,255,0.12)",
      label: dark ? "#93c5fd" : "#063164",
      bodyBg: dark ? "#1a2332" : "#ffffff",
      bodyText: dark ? "#e8eaed" : "#333333",
      muted: dark ? "#9aa0a6" : "#666666",
      divider: dark ? "#2d3b4e" : "#063164",
      msgPaper: dark ? "#252f3f" : "#f9f9f9",
      msgBorder: dark ? "#2d3b4e" : "#e0e0e0",
      tabSel: dark ? "#90caf9" : "#063164",
      tagBg: dark ? "rgba(96, 165, 250, 0.18)" : "#e3f2fd",
      tagFg: dark ? "#90caf9" : "#1976d2",
      primaryBtn: dark ? "#1976d2" : "#063164",
      listAccent: dark ? "#93c5fd" : "#063164",
    };
  }, [shellDark]);

  // Events for the currently selected date (mobile list view)
  const eventsForMobileDate = React.useMemo(() => {
    const d = moment(mobileSelectedDate).startOf("day");
    return events.filter((ev) => ev.start && moment(ev.start).isSame(d, "day"));
  }, [events, mobileSelectedDate]);

  const openEventModalFromCard = (event) => {
    setSelectedEvent({
      ...event.extendedProps,
      start: event.start,
      end: event.end,
    });
    setOpen(true);
  };

  const getMobileCardTitle = (event) => {
    const ep = event.extendedProps || {};
    const type = ep.type || "";
    const name = [ep.FirstName, ep.LastName].filter(Boolean).join(" ").trim();
    if (type === "visit") return name ? `Visit: ${name}` : (event.title ? `Visit: ${event.title}` : "Visit");
    if (type === "contract") return name ? `Contract: ${name}` : (event.title || `Contract #${ep.ContractNumber || ""}`);
    if (type === "invoice") return name ? `Invoice: ${name}` : (event.title || `Invoice #${ep.InvoiceNumber || ""}`);
    if (type === "quote") return event.title || "Quote";
    if (type === "message") return event.title || "Message";
    return event.title || "Event";
  };

  const getMobileCardDesc = (event) => {
    const ep = event.extendedProps || {};
    const type = ep.type || "";
    if (type === "visit") {
      const parts = [];
      if (ep.Title || event.title) parts.push(ep.Title || event.title);
      if (ep.VisitContractNumber) parts.push(`Contract #${ep.VisitContractNumber}`);
      return parts.join(" - ") || "";
    }
    if (type === "contract") return `Contract #${ep.ContractNumber || ""} - ${ep.Status || ""}`;
    if (type === "invoice") return `Invoice #${ep.InvoiceNumber || ""} - ${ep.Status === "paid" ? "Paid" : ep.Status || ""}`;
    if (type === "message") return ep.Message ? (ep.Message.length > 60 ? ep.Message.slice(0, 60) + "..." : ep.Message) : "";
    return "";
  };

  const getMobileCardButtonLabel = () => "View Info";

  const getMobileCardButtonClass = () => "";

  /** For mobile card: time display - "All day" or "9:00 AM - 5:00 PM" */
  const getMobileCardTimeLine = (event) => {
    if (event.allDay) return { isAllDay: true, text: "All day" };
    if (event.start && event.end) {
      return {
        isAllDay: false,
        text: `${moment(event.start).format("h:mm A")} - ${moment(event.end).format("h:mm A")}`,
      };
    }
    if (event.start) return { isAllDay: false, text: moment(event.start).format("h:mm A") };
    return { isAllDay: true, text: "All day" };
  };

  /** For mobile card: lines like "Client: Name", "Visit: Title" (only first letter capital) */
  const getMobileCardLines = (event) => {
    const ep = event.extendedProps || {};
    const type = ep.type || "";
    const name = [ep.FirstName, ep.LastName].filter(Boolean).join(" ").trim();
    const lines = [];
    if (name) lines.push(`Client: ${name}`);
    if (type === "visit") lines.push(`Visit: ${ep.Title || event.title || "Visit"}`);
    else if (type === "contract") lines.push(`Contract: #${ep.ContractNumber || ""} ${ep.Status || ""}`);
    else if (type === "invoice") lines.push(`Invoice: #${ep.InvoiceNumber || ""} ${ep.Status === "paid" ? "Paid" : ep.Status || ""}`);
    else if (type === "quote") lines.push(`Quote: ${event.title || ""}`);
    else if (type === "message") lines.push(ep.Message ? ep.Message.slice(0, 50) + (ep.Message.length > 50 ? "..." : "") : "Message");
    else if (event.title) lines.push(event.title);
    return lines;
  };

  /** Week (7 days) containing mobileSelectedDate for the day strip */
  const mobileWeekDays = React.useMemo(() => {
    const start = moment(mobileSelectedDate).startOf("week");
    return Array.from({ length: 7 }, (_, i) => moment(start).add(i, "days").toDate());
  }, [mobileSelectedDate]);

  // Use timezone-aware date formatter hook
  const formatDateWithUserTimezone = useUserTimezoneFormatter();

  // Type accent colors — fixed per entity type so users can identify type at a glance
  // (color encodes TYPE; a small status dot encodes status — see getStatusDot)
  const TYPE_ACCENT = {
    quote:    "#3b82f6", // blue
    contract: "#8b5cf6", // violet
    visit:    "#14b8a6", // teal
    invoice:  "#f59e0b", // amber
  };

  // Status dots — fixed semantic meaning regardless of type
  const DOT_OK   = "#10b981"; // green: paid / approved / completed
  const DOT_WARN = "#f59e0b"; // amber: awaiting / today
  const DOT_BAD  = "#ef4444"; // red: unpaid / late / unscheduled
  const DOT_IDLE = "#94a3b8"; // slate: pending / scheduled / upcoming

  // Shared neutral chip background — keeps the calendar visually quiet so accents pop
  const CHIP_BG = "#ffffff";

  const buildStyle = (type, dot) => ({
    accent: TYPE_ACCENT[type],
    dot,
    backgroundColor: CHIP_BG,
    borderColor: TYPE_ACCENT[type],
    textColor: "#1f2937",
  });

  const getInvoiceColors = (status) => {
    const s = (status || "").toLowerCase();
    return buildStyle("invoice", s === "paid" ? DOT_OK : DOT_BAD);
  };

  const getContractColors = (status) => {
    const s = (status || "").toLowerCase();
    let dot = DOT_IDLE;
    if (s === "converted" || s === "upcoming" || s === "today") dot = DOT_OK;
    else if (s === "scheduled") dot = DOT_WARN;
    else if (s === "unscheduled") dot = DOT_BAD;
    return buildStyle("contract", dot);
  };

  const getQuoteColors = (status) => {
    const s = (status || "").toLowerCase();
    let dot = DOT_IDLE;
    if (s === "approved") dot = DOT_OK;
    else if (s === "awaiting response") dot = DOT_WARN;
    return buildStyle("quote", dot);
  };

  const getVisitColors = (visit) => {
    const status = (visit?.Status || "").toLowerCase();
    const isCompleted = status === "completed" || status === "complete" || visit?.IsComplete === true;
    const isConfirmed = status === "confirmed" || visit?.IsConfirm === true || visit?.IsConfirmByWorker === true;
    const isLate = status === "late";
    const isToday = visit?.StartDate && moment(visit.StartDate).isSame(moment(), "day");

    let dot = DOT_IDLE;
    if (isCompleted) dot = DOT_OK;
    else if (isLate) dot = DOT_BAD;
    else if (isToday) dot = DOT_WARN;
    else if (isConfirmed) dot = DOT_OK;
    return buildStyle("visit", dot);
  };

  
  const fetchCustomerData = async () => {
    try {
      const token =
        getItem("adminToken") ||
        getItem("workerToken");
      if (!token) {
        return;
      }

      const res = await AxiosInstance.post(`/v1/auth/token_data`, { token });

      if (res?.data?.data?.CompanyId) {
        const companyId = res?.data?.data?.CompanyId;

        const customerRes = await AxiosInstance.get(
          `/v1/customer/get_customer/${companyId}`
        );

        if (customerRes?.data?.statusCode === 200) {
          const customers = customerRes?.data?.data;

          setCustomerData(customers);
        } else {
          console.error("Customer API error:", customerRes?.data);
        }
      } else {
        console.error("No CompanyId found in token data");
      }
    } catch (error) {
      console.error("Error fetching customer data:", error?.message);
      console.error("Full error:", error);
    }
  };

  
  const fetchCustomerMessagesByDate = async (date) => {
    try {
      setIsLoadingMessages(true);

      
      const dateStr = new Date(date).toISOString().split("T")[0];

      const response = await AxiosInstance.get(
        `/v1/customer-message/date/${dateStr}`
      );
      if (response?.data?.success === true) {
        const messages = response?.data?.data || [];
        setExistingMessages(messages);
      } else {
        console.error("API response error:", response?.data);
        setExistingMessages([]);
      }
    } catch (error) {
      console.error("Error fetching customer events by date:", error);
      console.error("Error response:", error?.response?.data);
      setExistingMessages([]);
    } finally {
      setIsLoadingMessages(false);
    }
  };

  
  const fetchCustomerMessageByEventId = async (EventId) => {
    try {
      const response = await AxiosInstance.get(
        `/v1/customer-message/event/${EventId}`
      );
      if (response?.data?.success === true) {
        const message = response?.data?.data;
        return message;
      } else {
        console.error("API response error:", response?.data);
        return null;
      }
    } catch (error) {
      console.error("Error fetching customer event by EventId:", error);
      console.error("Error response:", error?.response?.data);
      return null;
    }
  };

  
  const fetchCustomerMessageByEventIdAndDate = async (EventId, date) => {
    try {
      
      const dateStr = new Date(date).toISOString().split("T")[0];

      const response = await AxiosInstance.get(
        `/v1/customer-message/event/${EventId}/date/${dateStr}`
      );

      if (response?.data?.success === true) {
        const message = response?.data?.data;
        return message;
      } else {
        console.error("API response error:", response?.data);
        return null;
      }
    } catch (error) {
      console.error(
        "Error fetching customer event by EventId and date:",
        error
      );
      console.error("Error response:", error?.response?.data);
      return null;
    }
  };

  useEffect(() => {
    fetchCustomerData();
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const { CompanyUrl } = useParams();
  const calendarRef = React.useRef(null);

  const fetchScheduleData = async () => {
    try {
      const res = await AxiosInstance.get(`/v1/quote/schedule`);
      const scheduleData = res?.data?.data;

      
      const quoteScheduleData = scheduleData?.filter((item) => !item.EventId);

      const mappedEvents = quoteScheduleData?.map((item) => {
        const quoteColors = getQuoteColors(item?.Status);
        return {
          id: item?._id,
          title: item?.Title || `Quote #${item?.QuoteNumber}`,
          // Use parseLocalDate to prevent timezone-related date shifting
          start: parseLocalDate(
            item?.scheduleDate || moment(item?.Timestamp).startOf("day")
          ),
          end: parseLocalDate(
            item?.scheduleDate || moment(item?.Timestamp).endOf("day")
          ),
          allDay: true,
          backgroundColor: quoteColors.backgroundColor,
          borderColor: quoteColors.borderColor,
          textColor: quoteColors.textColor,
          classNames: ["quote-event"],
          extendedProps: {
            type: "quote",
            _accent: quoteColors.accent,
            _dot: quoteColors.dot,
            QuoteId: item?.QuoteId,
            Title: item?.Title,
            QuoteNumber: item?.QuoteNumber,
            Status: item?.Status,
            FirstName: item?.FirstName || item?.customer?.FirstName,
            LastName: item?.LastName || item?.customer?.LastName,
            Address: item?.Address || item?.location?.Address,
            City: item?.City || item?.location?.City,
            State: item?.State || item?.location?.State,
            Country: item?.Country || item?.location?.Country,
            Zip: item?.Zip || item?.location?.Zip,
          },
        };
      });

      return mappedEvents;
    } catch (error) {
      console.error("Error:", error?.message);
      return [];
    }
  };

  const fetchContractScheduleData = async () => {
    try {
      const res = await AxiosInstance.get(
        `/v1/contract/contract-schedule`
      );
      const contractData = res?.data?.data;
      const mappedContractEvents = contractData.map((contract) => {
        // Determine start date - check multiple sources
        let startDate = null;
        
        if (contract?.StartDate) {
          startDate = parseLocalDate(contract.StartDate);
        } else if (contract?.IsOneoffJob && contract?.OneoffJob?.StartDate) {
          startDate = parseLocalDate(contract.OneoffJob.StartDate);
        } else if (contract?.IsRecuringJob && contract?.RecuringJob?.StartDate) {
          startDate = parseLocalDate(contract.RecuringJob.StartDate);
        } else if (contract?.scheduleDate) {
          startDate = parseLocalDate(contract.scheduleDate);
        } else if (contract?.createdAt) {
          startDate = parseLocalDate(contract.createdAt);
        } else {
          startDate = parseLocalDate(new Date());
        }

        // Determine end date - check multiple sources
        let endDate = null;
        
        // First check CompletionDate (string)
        if (contract?.CompletionDate) {
          try {
            const parsedDate = moment(contract.CompletionDate);
            if (parsedDate.isValid()) {
              endDate = parseLocalDate(parsedDate.toDate());
            }
          } catch (error) {
            console.warn("Error parsing CompletionDate:", contract.CompletionDate, error);
          }
        }
        
        // If no CompletionDate, check OneoffJob.EndDate
        if (!endDate && contract?.IsOneoffJob && contract?.OneoffJob?.EndDate) {
          endDate = parseLocalDate(contract.OneoffJob.EndDate);
        }
        
        // If still no endDate, check RecuringJob (might have Duration or calculated end)
        // For recurring jobs, we might need to calculate end based on Duration
        // For now, if no end date, use startDate (will show as single day)
        if (!endDate) {
          endDate = startDate;
        }

        // Ensure endDate is not before startDate
        if (endDate < startDate) {
          endDate = startDate;
        }

        // FullCalendar uses exclusive end dates
        // If endDate is Dec 20, we want it to show through Dec 20
        // So end should be Dec 21 00:00:00 (which FullCalendar interprets as "up to but not including Dec 21")
        // This means it will display Dec 10-20 inclusive (11 days total)
        const endDateExclusive = moment(endDate).add(1, 'day').startOf('day').toDate();

        // Calculate if this is a multi-day event
        const daysDiff = moment(endDate).diff(moment(startDate), 'days');
        const isMultiDay = daysDiff >= 0; // Allow same day (0 days) to still show as a bar

        // Get colors based on contract status
        const contractColors = getContractColors(contract?.Status);

        // Build event object - ALWAYS include end date to ensure continuous line
        const eventObj = {
          id: contract?._id || contract?.ContractId,
          title: contract?.Title || `Contract #${contract?.ContractNumber}`,
          start: startDate,
          end: endDateExclusive, // Always include end date for continuous display
          allDay: true,
          backgroundColor: contractColors.backgroundColor,
          borderColor: contractColors.borderColor,
          textColor: contractColors.textColor,
          classNames: ["contract-event"], // Add class name for CSS targeting
          extendedProps: {
            type: "contract",
            _accent: contractColors.accent,
            _dot: contractColors.dot,
            ContractId: contract?.ContractId,
            Title: contract?.Title,
            ContractNumber: contract?.ContractNumber,
            FirstName: contract?.FirstName,
            LastName: contract?.LastName,
            Address: contract?.Address,
            City: contract?.City,
            State: contract?.State,
            Country: contract?.Country,
            Zip: contract?.Zip,
            Status: contract?.Status,
            StartDate: contract?.StartDate,
            CompletionDate: contract?.CompletionDate,
            IsOneoffJob: contract?.IsOneoffJob,
            IsRecuringJob: contract?.IsRecuringJob,
            OneoffJob: contract?.OneoffJob, // Include OneoffJob for EndDate access
            RecuringJob: contract?.RecuringJob, // Include RecuringJob for potential end date
          },
        };

        return eventObj;
      });
      return mappedContractEvents;
    } catch (error) {
      console.error("Error fetching contract schedule:", error?.message);
      return [];
    }
  };
  const fetchVisitScheduleData = async () => {
    try {
      const res = await AxiosInstance.get(`/v1/visit/visit-schedule`);
      const visitData = res?.data?.data;
      const mappedVisitEvents = visitData?.map((visit) => {
        const visitColors = getVisitColors(visit);
        return {
          id: visit?.VisitId,
          title: visit?.ItemName || `Visit (Contract #${visit?.ContractNumber})`,
          // Use parseLocalDate to prevent timezone-related date shifting
          start: parseLocalDate(visit?.StartDate),
          end: parseLocalDate(visit?.StartDate), // Use same date for start and end to prevent multi-day spanning
          allDay: true, // Mark as all-day event to ensure proper single-day display
          backgroundColor: visitColors.backgroundColor,
          borderColor: visitColors.borderColor,
          textColor: visitColors.textColor,
          classNames: ["visit-event"],
          extendedProps: {
            type: "visit",
            _accent: visitColors.accent,
            _dot: visitColors.dot,
            VisitId: visit?.VisitId,
            VisitContractId: visit?.ContractId,
            Title: visit?.ItemName,
            Note: visit?.Note,
            FirstName: visit?.FirstName,
            LastName: visit?.LastName,
            VisitContractNumber: visit?.ContractNumber,
            Address: visit?.Address,
            City: visit?.City,
            State: visit?.State,
            Zip: visit?.Zip,
            Country: visit?.Country,
            Status: visit?.Status,
            IsComplete: visit?.IsComplete,
            IsConfirm: visit?.IsConfirm,
            IsConfirmByWorker: visit?.IsConfirmByWorker,
            IsDelete: visit?.IsDelete,
          },
        };
      });

      return mappedVisitEvents;
    } catch (error) {
      console.error("Error fetching visit schedule:", error?.message);
      return [];
    }
  };
  const fetchInvoiceScheduleData = async () => {
    try {
      const res = await AxiosInstance.get(
        `/v1/invoice/invoice_schedule`
      );
      const invoiceData = res.data.data;
      const mappedInvoiceEvents = invoiceData.map((item) => {
        const invoiceColors = getInvoiceColors(item?.Status);
        return {
          id: item?._id,
          title: item?.Title || `Invoice #${item?.InvoiceNumber}`,
          // Use parseLocalDate to prevent timezone-related date shifting
          start: parseLocalDate(item?.sheduleDate),
          end: parseLocalDate(item?.sheduleDate),
          allDay: true,
          backgroundColor: invoiceColors.backgroundColor,
          borderColor: invoiceColors.borderColor,
          textColor: invoiceColors.textColor,
          classNames: ["invoice-event"],
          extendedProps: {
            type: "invoice",
            _accent: invoiceColors.accent,
            _dot: invoiceColors.dot,
            InvoiceId: item?.InvoiceId,
            FirstName: item?.FirstName,
            LastName: item?.LastName,
            Address: item?.Address,
            City: item?.City,
            State: item?.State,
            Zip: item?.Zip,
            Country: item?.Country,
            Title: item?.Title,
            InvoiceNumber: item?.InvoiceNumber,
            Status: item?.Status,
          },
        };
      });
      return mappedInvoiceEvents;
    } catch (error) {
      console.error("Error fetching invoice schedule:", error?.message);
      return [];
    }
  };

  
  const fetchCustomerMessageScheduleData = async () => {
    try {
      
      const res = await AxiosInstance.get(
        `/v1/customer-message/with-details`
      );

      if (res?.data?.success === true) {
        const messageData = res?.data?.data || [];

        if (messageData.length === 0) {
          return [];
        }

        const mappedMessageEvents = messageData.map((message, index) => {
          const displayMessage =
            message.Message && message.Message.length > 50
              ? message.Message.substring(0, 50) + "..."
              : message.Message || "No message";

          const mappedEvent = {
            id: message.EventId,
            title: displayMessage,
            // Use parseLocalDate to prevent timezone-related date shifting
            start: parseLocalDate(message.Timestamp),
            end: parseLocalDate(message.Timestamp),
            allDay: true,
            backgroundColor: "#f3f4f6", // Pale Gray for customer messages
            borderColor: "#6b7280",
            textColor: "#000000", // Black text for maximum contrast
            extendedProps: {
              type: "message",
              EventId: message.EventId,
              Title: displayMessage,
              Message: message.Message, 
              MessageId: message.EventId || message._id,
              CreatedBy: message.CreatedBy,
              CreatedByUserRole: message.CreatedByUserRole,
              Timestamp: message.Timestamp,
              CreatedAt: message.createdAt || message.Timestamp,
              UpdatedAt: message.updatedAt,
              Status: "Active", 
              IsRead: false, 
              Priority: "Normal", 
              MessageType: "General", 
              Attachments: [], 
              Tags: [], 
              CustomerId: message.CustomerId,
              LocationId: message.LocationId,
              FirstName: message.customer?.FirstName || "Unknown",
              LastName: message.customer?.LastName || "",
              PhoneNumber: message.customer?.PhoneNumber || "",
              EmailAddress: message.customer?.EmailAddress || "",
              Address: message.location?.Address || "",
              City: message.location?.City || "",
              State: message.location?.State || "",
              Country: message.location?.Country || "",
              Zip: message.location?.Zip || "",
              CompanyId: message.CompanyId,
              UserId: message.CustomerId,
              IsActive: true, 
              IsDeleted: false, 
              CreatedByUserId: message.CreatedByUserId,
              UpdatedByUserId: message.UpdatedByUserId,
            },
          };

          return mappedEvent;
        });

        return mappedMessageEvents;
      } else {
        console.error("Customer messages API error:", res?.data);
        console.error("API returned success: false");
        return [];
      }
    } catch (error) {
      console.error(
        "Error fetching customer message schedule:",
        error?.message
      );
      console.error("Full error:", error);
      console.error("Error response:", error?.response?.data);
      console.error("Error status:", error?.response?.status);
      return [];
    }
  };

  // Fetch date format and name format from settings
  const fetchDateFormat = async () => {
    try {
      const res = await handleAuth(navigate, location);

      // Pull the user's configured timezone so FullCalendar can render
      // dates / today highlight in that zone instead of the browser's.
      const tz = res?.data?.Timezone;
      if (tz && typeof tz === "string" && tz.trim()) {
        setUserTimezone(tz.trim());
      }

      // Fetch date format
      const CompanyId = getItem("CompanyId");
      if (CompanyId) {
        const response = await AxiosInstance.get(`/v1/theme/${CompanyId}`);
        if (response?.data?.statusCode === 200) {
          const format = response?.data?.data?.Format;
          if (format && format !== "" && format !== null) {
            try {
              const testDate = moment();
              const formatted = testDate.format(format);
              if (formatted && formatted !== "Invalid date" && formatted.length > 0) {
                setDateFormat(format);
              } else {
                setDateFormat("MM/DD/YYYY");
              }
            } catch (error) {
              console.error("Invalid date format:", format, error);
              setDateFormat("MM/DD/YYYY");
            }
          } else {
            setDateFormat("MM/DD/YYYY");
          }
        }
      }
      
    } catch (error) {
      console.error("Error fetching date format:", error);
      setDateFormat("MM/DD/YYYY");
    }
  };

  useEffect(() => {
    fetchDateFormat();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const [
        scheduleEvents,
        contractEvents,
        invoiceEvents,
        visitEvents,
        messageEvents,
      ] = await Promise.all([
        fetchScheduleData(),
        fetchContractScheduleData(),
        fetchInvoiceScheduleData(),
        fetchVisitScheduleData(),
        fetchCustomerMessageScheduleData(),
      ]);

      const allEvents = [
        ...scheduleEvents,
        ...contractEvents,
        ...invoiceEvents,
        ...visitEvents,
        ...messageEvents,
      ];

      setEvents(allEvents);
      setLoading(false);
    };

    fetchData();
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
    };
  }, [clickTimeout]);

  // Fix all-day text color in list view after calendar renders
  useEffect(() => {
    const fixAllDayTextColor = () => {
      // Use multiple selectors to catch all variations
      const selectors = [
        '.fc-list-view .fc-list-event-time',
        '.fc-list-event-time',
        '.fc-list-view .fc-slot-label',
        '.fc-slot-label',
        '.fc-list-view td[class*="time"]',
      ];

      selectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el) => {
          const text = el.textContent?.toLowerCase() || "";
          if (text.includes("all-day") || text.includes("all day")) {
            el.style.setProperty("color", sched.listAccent, "important");
            el.style.setProperty("font-weight", "500", "important");
            // Fix child elements
            const children = el.querySelectorAll("*");
            children.forEach((child) => {
              child.style.setProperty("color", sched.listAccent, "important");
            });
          }
        });
      });
    };

    // Run immediately and after a delay to catch delayed rendering
    fixAllDayTextColor();
    const timeout1 = setTimeout(fixAllDayTextColor, 100);
    const timeout2 = setTimeout(fixAllDayTextColor, 500);
    const timeout3 = setTimeout(fixAllDayTextColor, 1000);

    // Also observe DOM changes
    const observer = new MutationObserver(() => {
      fixAllDayTextColor();
    });

    const calendarElement = document.querySelector('.fc');
    if (calendarElement) {
      observer.observe(calendarElement, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
      observer.disconnect();
    };
  }, [events, currentView, sched.listAccent]);

  const renderEventContent = (eventInfo) => {
    const { event } = eventInfo;
    const ext = event?.extendedProps || {};

    const firstName = ext.FirstName || "";
    const lastName = ext.LastName || "";
    const customerName = `${firstName} ${lastName}`.trim();
    const title = ext.Title || event?.title || "";

    // Type label + primary number — color already encodes type so we keep this short
    let typeLabel = "";
    let number = "";
    if (ext.QuoteId || ext.QuoteNumber) {
      typeLabel = "Quote";
      number = ext.QuoteNumber;
    } else if (ext.ContractId || ext.ContractNumber) {
      typeLabel = "Contract";
      number = ext.ContractNumber;
    } else if (ext.InvoiceId || ext.InvoiceNumber) {
      typeLabel = "Invoice";
      number = ext.InvoiceNumber;
    } else if (ext.VisitId || ext.VisitContractId) {
      typeLabel = "Visit";
      number = ext.VisitContractNumber;
    } else if (ext.EventId) {
      typeLabel = "Event";
    }

    const numberLabel = number ? `${typeLabel} #${number}` : typeLabel;
    const customerLabel = customerName || "Unknown";
    const titleLabel = title || "—";

    // Tooltip carries the full context that the chip can't fit
    const tooltipLines = [
      [typeLabel, numberLabel].filter(Boolean).join(" "),
      customerLabel,
      titleLabel,
    ].filter(Boolean);
    const fullTooltipText = tooltipLines.join("\n");

    const accent = ext._accent || event.borderColor || "#94a3b8";
    const dot = accent; // dot mirrors the left accent bar — single color per chip
    const isCustomerEvent = !!ext.EventId;

    return (
      <Tooltip
        title={fullTooltipText}
        placement="top"
        arrow
        enterDelay={500}
        leaveDelay={200}
      >
        <div
          className={`event-container chip-v2 ${!isCustomerEvent ? "no-drag" : ""}`}
          style={{ "--chip-accent": accent, "--chip-dot": dot || "transparent" }}
          onMouseDown={(e) => {
            if (!isCustomerEvent) e.stopPropagation();
          }}
        >
          <span className="chip-accent-bar" aria-hidden="true" />
          <span className="chip-body">
            {numberLabel && <span className="chip-num">{numberLabel}</span>}
            <span className="chip-text">
              <span className="chip-customer">{customerLabel}</span>
              <span className="chip-sep"> · </span>
              <span className="chip-title">{titleLabel}</span>
            </span>
          </span>
          {dot && <span className="chip-dot" aria-hidden="true" />}
        </div>
      </Tooltip>
    );
  };

  const eventPropGetter = (event) => {
    const ext = event.extendedProps || {};
    const eventType = ext.type || "";
    const accent = ext._accent || event.borderColor || "#94a3b8";
    const dot = accent;

    const classNames = [];
    if (eventType) {
      classNames.push(`event-type-${eventType}`);
      if (eventType === "contract") classNames.push("contract-event");
      else if (eventType === "quote") classNames.push("quote-event");
      else if (eventType === "invoice") classNames.push("invoice-event");
      else if (eventType === "visit") classNames.push("visit-event");
    }

    return {
      classNames,
      style: {
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: "#1f2937",
        border: "none",
        borderRadius: "0",
        padding: "0",
        boxShadow: "none",
        "--chip-accent": accent,
        "--chip-dot": dot,
      },
    };
  };

  // Determine if an event is editable (only customer events can be dragged)
  const eventStartEditable = (event) => {
    // Only allow drag and drop for customer events
    // Return true only for customer events (with EventId)
    // Return false for all other events (quotes, contracts, invoices, visits)
    const isCustomerEvent = !!event?.extendedProps?.EventId;
    
    // Explicitly check and return false for non-customer events
    if (event?.extendedProps?.QuoteId || event?.extendedProps?.ContractId || 
        event?.extendedProps?.InvoiceId || event?.extendedProps?.VisitId) {
      return false;
    }
    
    return isCustomerEvent;
  };

  const handleEventClick = async (event) => {
    // Don't open modal if we just finished dragging
    if (isDragging) {
      setIsDragging(false);
      return;
    }
    
    // For customer events, add a small delay to allow drag to start
    // If drag starts, the modal won't open
    if (event?.extendedProps?.EventId) {
      // Clear any existing timeout
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
      
      // Store the event data for potential modal opening
      const eventData = {
        ...event?.extendedProps,
        start: event?.start,
        end: event?.end,
      };
      
      // Set a timeout to open modal only if no drag started
      const timeout = setTimeout(() => {
        // Only open if we're still not dragging
        setPendingClickEvent((prev) => {
          if (!isDragging && prev) {
            setSelectedEvent(eventData);
            setOpen(true);
          }
          return null;
        });
      }, 200); // 200ms delay to detect drag
      
      setClickTimeout(timeout);
      setPendingClickEvent(eventData);
    } else {
      // For non-customer events, open immediately
      if (event) {
        setSelectedEvent({
          ...event?.extendedProps,
          start: event?.start,
          end: event?.end,
        });
        setOpen(true);
      }
    }
  };

  // Track when drag starts
  const handleEventDragStart = (dragInfo) => {
    const event = dragInfo.event;
    
    // Only allow drag for customer events - prevent drag for all other events
    // Check multiple ways to ensure we catch all non-customer events
    const isCustomerEvent = !!event?.extendedProps?.EventId;
    const isNonCustomerEvent = !!(
      event?.extendedProps?.QuoteId || 
      event?.extendedProps?.ContractId || 
      event?.extendedProps?.InvoiceId || 
      event?.extendedProps?.VisitId
    );
    
    if (!isCustomerEvent || isNonCustomerEvent) {
      // Immediately prevent and stop drag for non-customer events
      dragInfo.jsEvent.preventDefault();
      dragInfo.jsEvent.stopPropagation();
      dragInfo.jsEvent.stopImmediatePropagation();
      
      // Force the event to revert to its original position
      setTimeout(() => {
        if (dragInfo.view && dragInfo.view.calendar) {
          const calendarApi = dragInfo.view.calendar.getApi();
          const originalEvent = calendarApi.getEventById(event.id);
          if (originalEvent) {
            originalEvent.setStart(event.start);
            originalEvent.setEnd(event.end);
          }
        }
      }, 0);
      
      return false; // Prevent drag
    }
    
    // Only set dragging flag for customer events
    setIsDragging(true);
    
    // Cancel any pending click timeout
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
    }
    setPendingClickEvent(null);
  };

  // Handle when drag is cancelled (user starts dragging but releases without dropping)
  const handleEventDragStop = (dragInfo) => {
    // If the event wasn't actually dropped (reverted), reset the flag after a short delay
    setTimeout(() => {
      setIsDragging(false);
    }, 50);
    
    // Clear any pending click
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
    }
    setPendingClickEvent(null);
  };

  // Handle drag and drop for customer events only
  const handleEventDrop = async (dropInfo) => {
    const event = dropInfo.event;
    
    // Only allow drag and drop for customer events
    if (!event?.extendedProps?.EventId) {
      // Revert the event position for non-customer events
      dropInfo.revert();
      // Reset dragging flag
      setIsDragging(false);
      return;
    }

    try {
      const newDate = dropInfo.event.start;
      const eventId = event.extendedProps.EventId;
      
      // Update the customer event date via API
      const response = await AxiosInstance.put(
        `/v1/customer-message/${eventId}`,
        {
          Message: event.extendedProps.Message || event.extendedProps.Title || "",
          Timestamp: newDate.toISOString(),
        }
      );

      if (response?.data?.success === true) {
        showToast.success("Customer event date updated successfully!");
        
        // Refresh customer message events in calendar
        await refreshCustomerMessageEvents();
        
        // Reset dragging flag after a short delay to prevent click from firing
        setTimeout(() => {
          setIsDragging(false);
        }, 100);
        
        // Clear any pending click
        if (clickTimeout) {
          clearTimeout(clickTimeout);
          setClickTimeout(null);
        }
        setPendingClickEvent(null);
      } else {
        console.error("API response error:", response?.data);
        showToast.error(
          response?.data?.message ||
            "Error updating customer event date. Please try again."
        );
      // Revert the event position on error
      dropInfo.revert();
      // Reset dragging flag
      setIsDragging(false);
      }
    } catch (error) {
      console.error("Error updating customer event date:", error);
      showToast.error("Error updating customer event date. Please try again.");
      // Revert the event position on error
      dropInfo.revert();
      // Reset dragging flag
      setIsDragging(false);
    }
    
    // Clear any pending click
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
    }
    setPendingClickEvent(null);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEvent(null);
    setIsEditingMessage(false);
    setEditMessageText("");
    setEditEventDate(null);
  };

  const handleDateClick = (dateInfo) => {
   
    setSelectedCustomer(null);
    
    setSelectedDate(dateInfo.date.toISOString());
    setSelectedDateTimestamp(dateInfo.date);

    setIsCustomerModalOpen(true);
    setCustomerMessage("");
    setMessageError("");
    setTabValue(0);

    
    fetchCustomerMessagesByDate(dateInfo.date);
  };

  const handleCustomerMessageClose = () => {
    setCustomerMessageOpen(false);
    setSelectedDate(null);
    setCustomerMessage("");
    setMessageError("");
    setTabValue(0);
    setExistingMessages([]);
    
    // setSelectedCustomer(null);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const validateMessage = (message) => {
    if (!message || message.trim() === "") {
      setMessageError("Message is required");
      return false;
    }

    if (message.trim().length > 500) {
      setMessageError("Message must be less than 500 characters");
      return false;
    }
    setMessageError("");
    return true;
  };

  const validateEditMessage = (message) => {
    if (!message || message.trim() === "") {
      setMessageError("Message is required");
      return false;
    }

    if (message.trim().length > 500) {
      setMessageError("Message must be less than 500 characters");
      return false;
    }
    setMessageError("");
    return true;
  };

  const handleMessageChange = (e) => {
    const value = e.target.value;
    setCustomerMessage(value);
    
    if (messageError) {
      setMessageError("");
    }
  };

  const handleEditMessageChange = (e) => {
    const value = e.target.value;
    setEditMessageText(value);
    
    if (messageError) {
      setMessageError("");
    }
  };

  const handleLocationSelection = (customerData, selectedLocation) => {
    
    const customerWithSelectedLocation = {
      ...customerData,
      selectedLocation: selectedLocation,
    };

    
    setIsCustomerModalOpen(false);
    setIsPropertyModalOpen(false);

    
    setTimeout(() => {
      setSelectedCustomer(customerWithSelectedLocation);

      
      setTimeout(() => {
        setCustomerMessageOpen(true);
      }, 50);
    }, 100);
  };

  const handleCustomerSelection = (customerData) => {
    
    if (!customerData) {
      console.error("No customer data provided to handleCustomerSelection");
      return;
    }

    // Check if customer has multiple addresses
    if (
      customerData.locationDetails &&
      customerData.locationDetails.length > 1
    ) {
      // Store customer data for later use when location is selected
      setCustomerData((prev) => {
        const existingIndex = prev.findIndex(
          (customer) => customer.UserId === customerData.UserId
        );
        if (existingIndex === -1) {
          return [...prev, customerData];
        } else {
          return prev.map((customer, index) =>
            index === existingIndex ? customerData : customer
          );
        }
      });
      // Don't open dialog yet, wait for location selection
      return;
    }

    // Single address or no address - proceed directly
    // Set the selected customer and close customer modal
    setSelectedCustomer(customerData);
    setIsCustomerModalOpen(false);
    setIsPropertyModalOpen(false);

    // Open customer message dialog with selected customer
    setTimeout(() => {
      setCustomerMessageOpen(true);
    }, 100); // Small delay to ensure modal is closed first
  };

  const fetchSelectedCustomer = async (customerId) => {
    try {
      const res = await AxiosInstance.get(
        `/v1/customer/detail/${customerId}`
      );

      if (res?.data?.statusCode === 200) {
        const customerData = res?.data?.data;

        if (!customerData) {
          console.error("Customer data is null or undefined");
          showToast.error(
            "No customer data received from server. Please try again."
          );
          return;
        }

        // For all customers, proceed directly - let CustomerModal handle multiple addresses
        handleCustomerSelection(customerData);
      } else {
        console.error("API response error:", res?.data);
        console.error("Status code:", res?.data?.statusCode);
        console.error("Message:", res?.data?.message);
        showToast.error(
          `Error fetching customer data: ${
            res?.data?.message || "Unknown error"
          }. Please try again.`
        );
      }
    } catch (error) {
      console.error("Error fetching customer data:", error?.message);
      console.error("Full error:", error);
      showToast.error("Error fetching customer data. Please try again.");
    }
  };

  // Utility function to get data by EventId and date - you can use this anywhere
  const getDataByEventIdAndDate = async (EventId, date) => {
    try {
      const messageData = await fetchCustomerMessageByEventIdAndDate(
        EventId,
        date
      );

      if (messageData) {
        return messageData;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error in getDataByEventIdAndDate:", error);
      return null;
    }
  };

  // Enhanced utility function to get customer message data by various criteria
  const getCustomerMessageData = async (criteria) => {
    try {
      let response = null;

      if (criteria.eventId && criteria.date) {
        // Get by EventId and date
        response = await fetchCustomerMessageByEventIdAndDate(
          criteria.EventId,
          criteria.date
        );
      } else if (criteria.eventId) {
        // Get by EventId only
        response = await fetchCustomerMessageByEventId(criteria.EventId);
      } else if (criteria.date) {
        // Get by date only
        response = await fetchCustomerMessagesByDate(criteria.date);
      } else if (criteria.customerId) {
        // Get by customer ID
        response = await AxiosInstance.get(
          `/v1/customer-message/customer/${criteria.customerId}`
        );
        response = response?.data?.success ? response.data.data : null;
      } else if (criteria.locationId) {
        // Get by location ID
        response = await AxiosInstance.get(
          `/v1/customer-message/location/${criteria.locationId}`
        );
        response = response?.data?.success ? response.data.data : null;
      }

      if (response) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error in getCustomerMessageData:", error);
      return null;
    }
  };

  // Function to refresh customer message events
  const refreshCustomerMessageEvents = async () => {
    try {
      const messageEvents = await fetchCustomerMessageScheduleData();

      // Update events state with new message events
      setEvents((prevEvents) => {
        // Remove old customer message events
        const filteredEvents = prevEvents.filter((event) => !event.EventId);
        // Add new customer message events
        return [...filteredEvents, ...messageEvents];
      });
    } catch (error) {
      console.error("Error refreshing customer message events:", error);
    }
  };

  // Test function to create a sample customer message for testing
  const createTestCustomerMessage = async () => {
    try {
      // Get first customer from customerData
      const firstCustomer = customerData[0];
      if (!firstCustomer) {
        return;
      }

      // Get first location from customer
      const firstLocation = firstCustomer.locationDetails?.[0];
      if (!firstLocation) {
        return;
      }

      const testMessage = {
        CustomerId: firstCustomer.UserId,
        LocationId: firstLocation.LocationId,
        Message:
          "Test customer message for calendar display - " +
          new Date().toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
      };

      const response = await AxiosInstance.post(
        `/v1/customer-message`,
        testMessage
      );

      if (response?.data?.success === true) {
        // Refresh the calendar events
        await refreshCustomerMessageEvents();
      } else {
        console.error("Failed to create test message:", response?.data);
      }
    } catch (error) {
      console.error("Error creating test customer message:", error);
    }
  };

  const handleSaveCustomerMessage = async () => {
    try {
      // Validate required fields
      if (!validateMessage(customerMessage)) {
        return;
      }

      if (!selectedCustomer) {
        showToast.warning("Please select a customer before saving.");
        return;
      }

      // Set loading state to true
      setIsSavingMessage(true);

      // Get the location ID - use selected location if available, otherwise use first location
      let locationId = null;
      if (selectedCustomer.selectedLocation) {
        locationId = selectedCustomer.selectedLocation.LocationId;
      } else if (
        selectedCustomer.locationDetails &&
        selectedCustomer.locationDetails.length > 0
      ) {
        locationId = selectedCustomer.locationDetails[0].LocationId;
      }

      if (!locationId) {
        showToast.warning(
          "No location found for the selected customer. Please select a customer with a valid location."
        );
        return;
      }

      // Prepare the API request data
      const requestData = {
        CustomerId: selectedCustomer.UserId,
        LocationId: locationId,
        Message: customerMessage.trim(),
        Timestamp: selectedDateTimestamp
          ? selectedDateTimestamp.toISOString()
          : new Date().toISOString(),
      };

      // Make API call to save customer message
      const response = await AxiosInstance.post(
        `/v1/customer-message`,
        requestData
      );
      // Check success from backend response
      if (response?.data?.success === true) {
        showToast.success("Customer message saved successfully!");
        // Refresh existing messages for the current date
        if (selectedDate) {
          fetchCustomerMessagesByDate(selectedDate);
        }
        // Refresh customer message events in calendar
        await refreshCustomerMessageEvents();
        handleCustomerMessageClose();
      } else {
        console.error("API response error:", response?.data);
        showToast.error(
          response?.data?.message ||
            "Error saving customer message. Please try again."
        );
      }
    } catch (error) {
      console.error("Error saving customer message:", error);
      console.error("Error response:", error?.response?.data);

      if (error?.response?.data?.message) {
        showToast.error(
          `Error saving customer message: ${error.response.data.message}`
        );
      } else {
        showToast.error("Error saving customer message. Please try again.");
      }
    } finally {
      // Set loading state to false regardless of success or failure
      setIsSavingMessage(false);
    }
  };

  const handleUpdateCustomerMessage = async () => {
    try {
      // Validate required fields
      if (!validateEditMessage(editMessageText)) {
        return;
      }

      if (!selectedEvent?.EventId) {
        showToast.warning("No message selected for editing.");
        return;
      }

      // Set loading state to true
      setIsUpdatingMessage(true);

      // Prepare the API request data
      const requestData = {
        Message: editMessageText.trim(),
        Timestamp: editEventDate ? editEventDate.toISOString() : selectedEvent.start.toISOString(),
      };

      // Make API call to update customer message
      
      const response = await AxiosInstance.put(
        `/v1/customer-message/${selectedEvent.EventId}`,
        requestData
      );
      

      // Check success from backend response
      if (response?.data?.success === true) {
        showToast.success("Customer message updated successfully!");
        
        // Refresh customer message events in calendar
        await refreshCustomerMessageEvents();
        
        // Close edit mode and refresh the dialog
        setIsEditingMessage(false);
        setEditMessageText("");
        
        // Refresh existing messages for the current date if we're in the message dialog
        if (selectedDate) {
          fetchCustomerMessagesByDate(selectedDate);
        }
        
        // Update the selected event with new message
        setSelectedEvent(prev => ({
          ...prev,
          Message: editMessageText.trim(),
          Title: editMessageText.trim().length > 50 
            ? editMessageText.trim().substring(0, 50) + "..." 
            : editMessageText.trim()
        }));
        
        // Close the dialog after successful update
        handleClose();
        
      } else {
        console.error("API response error:", response?.data);
        showToast.error(
          response?.data?.message ||
            "Error updating customer message. Please try again."
        );
      }
    } catch (error) {
      console.error("Error updating customer message:", error);
      console.error("Error response:", error?.response?.data);

      if (error?.response?.data?.message) {
        showToast.error(
          `Error updating customer message: ${error.response.data.message}`
        );
      } else {
        showToast.error("Error updating customer message. Please try again.");
      }
    } finally {
      // Set loading state to false regardless of success or failure
      setIsUpdatingMessage(false);
    }
  };

  const handleEditMessage = () => {
    if (selectedEvent?.EventId) {
      setEditMessageText(selectedEvent.Message || selectedEvent.Title || "");
      // Set the current event date for editing
      setEditEventDate(selectedEvent.start ? moment(selectedEvent.start) : moment());
      setIsEditingMessage(true);
    }
  };

  const handleCancelEdit = () => {
    setIsEditingMessage(false);
    setEditMessageText("");
    setEditEventDate(null);
  };

  const handleDeleteMessage = async () => {
    try {
      if (!selectedEvent?.EventId) {
        showToast.warning("No message selected for deletion.");
        return;
      }

      // Set loading state to true
      setIsDeletingMessage(true);

      // Make API call to delete customer message
      
      const response = await AxiosInstance.delete(
        `/v1/customer-message/${selectedEvent.EventId}`,
        {
          data: {
            DeleteReason: "Customer message deleted by user"
          }
        }
      );
      

      if (response?.data?.success === true) {
        showToast.success("Customer message deleted successfully!");
        
        await refreshCustomerMessageEvents();
        
        handleClose();
        
        if (selectedDate) {
          fetchCustomerMessagesByDate(selectedDate);
        }
        
      } else {
        console.error("API response error:", response?.data);
        showToast.error(
          response?.data?.message ||
            "Error deleting customer message. Please try again."
        );
      }
    } catch (error) {
      console.error("Error deleting customer message:", error);
      console.error("Error response:", error?.response?.data);

      if (error?.response?.data?.message) {
        showToast.error(
          `Error deleting customer message: ${error.response.data.message}`
        );
      } else {
        showToast.error("Error deleting customer message. Please try again.");
      }
    } finally {
      setIsDeletingMessage(false);
    }
  };

  if (loading) {
    return (
      <Grid className="Typography-5 m-2 m-md-3" sx={{ width: "100%", maxWidth: "100%" }}>
        <LoaderComponent
          variant="skeleton"
          skeletonLayout="page"
          skeletonMinHeight={"calc(100vh - 220px)"}
          loader={loading}
          height="50"
          width="50"
        />
      </Grid>
    );
  }

  return (
    <>
      <style dangerouslySetInnerHTML={{__html: `
        .event-container,
        .event-container *,
        .event-container .event-header,
        .event-container .event-details,
        .event-container .event-header-text,
        .event-container .event-details-text,
        .event-container .visit-label,
        .event-container .customer-message-label,
        .event-container .event-icon,
        .event-container .event-message-meta,
        .event-container span,
        .event-container div,
        .event-container p,
        .event-header-text,
        .visit-label,
        .customer-message-label,
        .event-details-text,
        .event-header,
        .event-details,
        .event-icon {
          color: #000000 !important;
        }
        .fc-event-title,
        .fc-event-time,
        .fc-event-title-container,
        .fc-event-main,
        .fc-event-segment,
        .fc-event-title-container *,
        .fc-event-main * {
          color: #000000 !important;
        }
        /* Fix all-day text color in list view */
        .fc-list-view .fc-list-event-time,
        .fc-list-view .fc-list-event-time *,
        .fc-list-view .fc-slot-label,
        .fc-list-view .fc-slot-label *,
        .fc-list-event-time,
        .fc-list-event-time * {
          color: ${sched.listAccent} !important;
        }
        .fc-list-day,
        .fc-list-day-text,
        .fc-list-day-side,
        .fc-list-day-cushion,
        .fc-list-day *,
        .fc-list-day-text *,
        .fc-list-day-side * {
          color: ${sched.listAccent} !important;
        }
      `}} />
      <Grid
        container
        spacing={2}
        sx={{
          width: "100%",
          maxWidth: "100%",
          margin: "0 auto",
          padding: { xs: "5px", sm: "10px", md: "20px" },
          borderRadius: "12px",
          boxShadow: "var(--shadow-md)",
          overflowX: "hidden",
        }}
      >

        <div className="calendar-wrapper desktop-view">
          <Box
            sx={{ 
              position: "relative", 
              maxWidth: "100%", 
              width: "100%",
              overflowX: "hidden",
              overflowY: "auto"
            }}
            ref={calendarRef}
          >
            <Box
              className="calender-main"
            onClick={(e) => {
              const dayCell = e.target.closest(".fc-daygrid-day");
              const eventElement = e.target.closest(".fc-event");
              const eventContainer = e.target.closest(".event-container");
              const moreLink = e.target.closest(".fc-more-link");
              const moreLinkText = e.target.closest(".fc-more");
              if (
                dayCell &&
                !eventElement &&
                !eventContainer &&
                !moreLink &&
                !moreLinkText
              ) {
                
                const dayCellDate = dayCell.getAttribute("data-date");
                if (dayCellDate) {
                  const clickedDate = new Date(dayCellDate);
                  handleDateClick({ date: clickedDate });
                } else {

                  const ariaLabel = dayCell.getAttribute("aria-label");
                  if (ariaLabel) {
                    const parsedDate = new Date(ariaLabel);
                    if (!isNaN(parsedDate.getTime())) {
                      handleDateClick({ date: parsedDate });
                    }
                  } else {
                    
                    const dayNumber = dayCell.querySelector(
                      ".fc-daygrid-day-number"
                    );
                    if (dayNumber) {
                      const dateStr = dayNumber.textContent;
                      const calendarApi = calendarRef.current?.getApi();
                      if (calendarApi) {
                        const currentView = calendarApi.view;
                        const viewStart = currentView.activeStart;
                        const clickedDate = new Date(
                          viewStart.getFullYear(),
                          viewStart.getMonth(),
                          parseInt(dateStr)
                        );
                        handleDateClick({ date: clickedDate });
                      }
                    }
                  }
                }
              }
            }}
            sx={{
              position: "relative",
              minWidth: "100%",
              maxWidth: "100%",
              width: "100%",
              height: "100%",
              // Ensure the calendar card (and loading skeleton overlay) has a stable height on initial load,
              // even before FullCalendar finishes measuring and rendering.
              minHeight: { xs: "60vh", md: "calc(100vh - 240px)" },
              overflow: "hidden",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "10px",
            }}
          >
            <FullCalendar
              plugins={[
                momentTimezonePlugin,
                dayGridPlugin,
                timeGridPlugin,
                listPlugin,
                interactionPlugin,
              ]}
              initialView={currentView}
              /* Render the calendar in the user's configured timezone so the
                 "today" highlight and event placement match the company's
                 timezone setting, not the browser's. Named zones require
                 @fullcalendar/moment-timezone — without it FC uses UTC-coercion
                 and weekday columns / "today" can be wrong. */
              timeZone={userTimezone}
              events={events}
              eventContent={renderEventContent}
              eventClick={(info) => handleEventClick(info.event)}
              eventDrop={handleEventDrop}
              eventDragStart={handleEventDragStart}
              eventDragStop={handleEventDragStop}
              dateClick={(info) => handleDateClick(info)}
              datesSet={(info) => {
                // Fix all-day text color when view changes
                setTimeout(() => {
                  const selectors = [
                    '.fc-list-view .fc-list-event-time',
                    '.fc-list-event-time',
                    '.fc-list-view .fc-slot-label',
                    '.fc-slot-label',
                  ];
                  selectors.forEach((selector) => {
                    const elements = document.querySelectorAll(selector);
                    elements.forEach((el) => {
                      const text = el.textContent?.toLowerCase() || "";
                      if (text.includes("all-day") || text.includes("all day")) {
                        el.style.setProperty("color", sched.listAccent, "important");
                        el.style.setProperty("font-weight", "500", "important");
                        const children = el.querySelectorAll("*");
                        children.forEach((child) => {
                          child.style.setProperty("color", sched.listAccent, "important");
                        });
                      }
                    });
                  });
                }, 100);
              }}
              selectable={true}
              selectMirror={true}
              unselectAuto={false}
              headerToolbar={{
                left: "prev,today,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
              }}
              eventPropGetter={eventPropGetter}
              eventStartEditable={eventStartEditable}
              eventDurationEditable={false}
              editable={true}
              droppable={true}
              height="auto"
              contentHeight="auto"
              slotMinTime="07:00:00"
              slotMaxTime="20:00:00"
              allDaySlot={true}
              slotDuration="01:00:00"
              slotLabelInterval="01:00:00"
              weekends={true}
              dayHeaderFormat={{ weekday: "short" }}
              /* No custom dayHeaderContent: moment(arg.date).format('ddd')
                 was off-by-one because FullCalendar passes arg.date as
                 midnight-UTC and moment converts to local time, which can
                 shift the weekday name. dayHeaderFormat above already
                 produces the correct abbreviation in the calendar's own
                 timezone. */
              slotLabelDidMount={(info) => {
                // Fix all-day label text color in list view
                if (info.text === "all-day" || info.text === "All Day" || info.text?.toLowerCase() === "all-day") {
                  if (info.el) {
                    info.el.style.color = sched.listAccent;
                    info.el.style.fontWeight = "500";
                    // Also fix any child elements
                    const childElements = info.el.querySelectorAll("*");
                    childElements.forEach((child) => {
                      child.style.color = sched.listAccent;
                    });
                  }
                }
              }}
              views={{
                timeGridWeek: {
                  slotLabelFormat: {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  },
                  allDaySlot: true,
                  dayHeaderFormat: { weekday: "short" },
                  /* dayHeaderContent removed — see top-level note. */
                },
                timeGridDay: {
                  slotLabelFormat: {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  },
                  allDaySlot: true,
                  dayHeaderFormat: { weekday: "short" },
                },
                dayGridMonth: {
                  allDaySlot: true,
                  /* Show all events on each date - no collapsing to "+N more" */
                  dayMaxEventRows: false,
                  dayHeaderFormat: { weekday: "short" },
                },
                listWeek: {
                  listDayFormat: { weekday: "long" },
                  slotLabelDidMount: (info) => {
                    // Fix all-day label text color in list view
                    const text = info.text?.toLowerCase() || "";
                    if (text.includes("all-day") || text.includes("all day") || text === "all-day") {
                      if (info.el) {
                        info.el.style.setProperty("color", sched.listAccent, "important");
                        info.el.style.setProperty("font-weight", "500", "important");
                        // Also fix any child elements
                        const childElements = info.el.querySelectorAll("*");
                        childElements.forEach((child) => {
                          child.style.setProperty("color", sched.listAccent, "important");
                        });
                        // Also check parent elements
                        let parent = info.el.parentElement;
                        while (parent && parent !== document.body) {
                          if (parent.classList.contains("fc-list-event-time") || 
                              parent.classList.contains("fc-slot-label")) {
                            parent.style.setProperty("color", sched.listAccent, "important");
                          }
                          parent = parent.parentElement;
                        }
                      }
                    }
                    // Also use a timeout to catch any delayed rendering
                    setTimeout(() => {
                      const allDayLabels = document.querySelectorAll('.fc-list-view .fc-list-event-time');
                      allDayLabels.forEach((el) => {
                        const text = el.textContent?.toLowerCase() || "";
                        if (text.includes("all-day") || text.includes("all day")) {
                          el.style.setProperty("color", sched.listAccent, "important");
                          el.style.setProperty("font-weight", "500", "important");
                          const children = el.querySelectorAll("*");
                          children.forEach((child) => {
                            child.style.setProperty("color", sched.listAccent, "important");
                          });
                        }
                      });
                    }, 100);
                  },
                },
              }}
              eventDisplay="block"
            />
          </Box>
          </Box>
        </div>

        {/* Mobile view: single-line date + week day strip + event cards + FAB */}
        <div className="calendar-wrapper mobile-view">
          <div className="mobile-schedule-inner">
            <header className="mobile-calendar-header">
              <button
                type="button"
                className="mobile-date-picker-trigger"
                onClick={() => setMobileDatePickerOpen(true)}
                aria-label="Select date"
              >
                <span className="mobile-date-one-line">
                  {moment(mobileSelectedDate).format("dddd MMMM D, YYYY")}
                </span>
                <CalendarMonthRoundedIcon className="mobile-date-picker-icon" />
              </button>
              <div className="mobile-day-strip">
                {mobileWeekDays.map((day) => {
                  const isSelected = moment(day).isSame(moment(mobileSelectedDate), "day");
                  const isToday = moment(day).isSame(moment(), "day");
                  return (
                    <button
                      key={day.getTime()}
                      type="button"
                      className={`mobile-day-dot ${isSelected ? "selected" : ""}${isToday ? " is-today" : ""}`}
                      onClick={() => setMobileSelectedDate(day)}
                      aria-label={moment(day).format("ddd MMM D")}
                    >
                      {moment(day).format("ddd").charAt(0)}
                    </button>
                  );
                })}
              </div>
            </header>
            <div className="mobile-event-list">
              {eventsForMobileDate.length === 0 ? (
                <p className="mobile-no-events">No events on this date.</p>
              ) : (
                eventsForMobileDate.map((event) => {
                  const timeLine = getMobileCardTimeLine(event);
                  const lines = getMobileCardLines(event);
                  return (
                    <div
                      key={event.id}
                      className={`event-card-mobile type-${event.extendedProps?.type || "default"}`}
                      onClick={() => openEventModalFromCard(event)}
                    >
                      <div className="event-card-mobile-time">
                        {timeLine.isAllDay ? (
                          <span className="event-time-all-day">{timeLine.text}</span>
                        ) : (
                          <span className="event-time-range">{timeLine.text}</span>
                        )}
                      </div>
                      {lines.length > 0 && (
                        <div className="event-card-mobile-lines">
                          {lines.map((line, idx) => (
                            <div key={idx} className="event-card-mobile-line">
                              {line}
                            </div>
                          ))}
                        </div>
                      )}
                      <button
                        type="button"
                        className={`view-details-btn ${getMobileCardButtonClass()}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          openEventModalFromCard(event);
                        }}
                      >
                        {getMobileCardButtonLabel()}
                      </button>
                    </div>
                  );
                })
              )}
            </div>
          </div>
          <button
            type="button"
            className="mobile-fab"
            onClick={() => handleDateClick({ date: mobileSelectedDate })}
            aria-label="Create task"
          >
            <span className="mobile-fab-icon">+</span>
          </button>
        </div>

        {/* Mobile: date picker dialog - select any date to view events */}
        <Dialog
          open={mobileDatePickerOpen}
          onClose={() => setMobileDatePickerOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            style: { borderRadius: 16, padding: 8 },
          }}
          className="mobile-date-picker-dialog"
        >
          <DialogTitle style={{ textAlign: "center", paddingBottom: 0 }}>
            Select date
          </DialogTitle>
          <DialogContent style={{ paddingTop: 8 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                value={dayjs(mobileSelectedDate)}
                onChange={(newDate) => {
                  if (newDate) {
                    setMobileSelectedDate(newDate.toDate());
                    setMobileDatePickerOpen(false);
                  }
                }}
                showDaysOutsideCurrentMonth
              />
            </LocalizationProvider>
          </DialogContent>
        </Dialog>

        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth="sm"
          className="schedule-event-detail-dialog"
          scroll="paper"
          PaperProps={{
            sx: {
              borderRadius: "12px",
              overflow: "hidden",
              border: `1px solid ${sched.divider}`,
              bgcolor: sched.bodyBg,
              boxShadow: "var(--shadow-lg)",
              display: "flex",
              flexDirection: "column",
              maxHeight: isMobileModal ? "90vh" : "min(92vh, 720px)",
              m: isMobileModal ? "12px" : undefined,
              maxWidth: { xs: "calc(100% - 24px)", sm: "520px" },
            },
          }}
        >
          {(() => {
            const titleText = selectedEvent
              ? selectedEvent?.QuoteId
                ? "Quote Details"
                : selectedEvent?.ContractId
                ? "Contract Details"
                : selectedEvent?.VisitId
                ? "Visit Details"
                : selectedEvent?.EventId
                ? "Customer Event Details"
                : "Invoice Details"
              : "Details";

            const customerName = [selectedEvent?.FirstName, selectedEvent?.LastName]
              .filter(Boolean)
              .join(" ")
              .trim();
            const numberLabel = selectedEvent?.QuoteId
              ? `Quote #${selectedEvent?.QuoteNumber || ""}`
              : selectedEvent?.ContractId
              ? `Contract #${selectedEvent?.ContractNumber || ""}`
              : selectedEvent?.VisitId
              ? `Visit · Contract #${selectedEvent?.VisitContractNumber || ""}`
              : selectedEvent?.InvoiceId
              ? `Invoice #${selectedEvent?.InvoiceNumber || ""}`
              : "";
            const subtitleText = [numberLabel, customerName].filter(Boolean).join(" · ");

            return (
              <DialogTitle
                className="schedule-event-dialog-title"
                sx={{
                  m: 0,
                  px: { xs: 2.5, sm: 3 },
                  pt: { xs: 2, sm: 2.5 },
                  pb: 1.75,
                  background: "#ffffff",
                  borderBottom: "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 1.5,
                }}
              >
                <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>
                  <Typography
                    component="div"
                    className="schedule-event-dialog-title-text"
                    sx={{
                      fontSize: { xs: "1.0625rem", sm: "1.125rem" },
                      fontWeight: 600,
                      color: "#0f172a",
                      lineHeight: 1.3,
                      letterSpacing: "-0.01em",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {titleText}
                  </Typography>
                  {subtitleText && (
                    <Typography
                      component="div"
                      sx={{
                        mt: 0.25,
                        fontSize: { xs: "0.8125rem", sm: "0.875rem" },
                        fontWeight: 400,
                        color: "#64748b",
                        lineHeight: 1.4,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {subtitleText}
                    </Typography>
                  )}
                </Box>
                <IconButton
                  type="button"
                  onClick={handleClose}
                  aria-label="Close dialog"
                  size="small"
                  sx={{
                    flexShrink: 0,
                    mt: -0.25,
                    color: "#64748b",
                    borderRadius: "8px",
                    "&:hover": { bgcolor: "#f1f5f9", color: "#0f172a" },
                  }}
                >
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
            );
          })()}
          <DialogContent
            className="schedule-event-detail-dialog-content"
            sx={{
              background: sched.bodyBg,
              color: sched.bodyText,
              padding: { xs: "16px 20px 12px", sm: "20px 24px 16px" },
            }}
          >
            <div style={{ marginBottom: 16 }}>
              <Grid container spacing={0} className="schedule-event-detail-fields">
                {selectedEvent?.VisitId && (
                  <Grid size={12}>
                    <div
                      style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                    >
                      Contract Number
                    </div>
                    <div style={{ color: sched.bodyText, fontSize: 15 }}>
                      Visit ( Contract #{selectedEvent?.VisitContractNumber} )
                    </div>
                  </Grid>
                )}
                <Grid size={12}>
                  <div
                    style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                  >
                    {selectedEvent?.QuoteId
                      ? "Quote Number"
                      : selectedEvent?.ContractId
                      ? "Contract Number"
                      : selectedEvent?.VisitId
                      ? "Visit Title"
                      : selectedEvent?.EventId
                      ? "Event Title"
                      : "Invoice Number"}
                  </div>
                  <div style={{ color: sched.bodyText, fontSize: 15 }}>
                    {selectedEvent
                      ? selectedEvent?.QuoteId
                        ? `Quote #${selectedEvent?.QuoteNumber}`
                        : selectedEvent?.ContractId
                        ? `Contract #${selectedEvent?.ContractNumber}`
                        : selectedEvent?.VisitId
                        ? selectedEvent?.Title
                        : selectedEvent?.EventId
                        ? (isEditingMessage ? (
                            <Box>
                              <InputText
                                fullWidth
                                multiline
                                rows={3}
                                value={editMessageText}
                                onChange={handleEditMessageChange}
                                placeholder="Enter your message description here..."
                                error={!!messageError}
                                helperText={messageError}
                                inputProps={{
                                  maxLength: 500,
                                }}
                                ariaLabel="Event message"
                                style={{ marginBottom: 16 }}
                              />
                              <DatePicker
                                name="editEventDate"
                                label="Event Date"
                                value={editEventDate ? editEventDate.toISOString() : ""}
                                onChange={(e) => {
                                  if (e.target.value) {
                                    setEditEventDate(moment(e.target.value));
                                  } else {
                                    setEditEventDate(null);
                                  }
                                }}
                                format={dateFormat}
                                className="edit-event-date-picker"
                              />
                            </Box>
                          ) : (
                            selectedEvent?.Message || selectedEvent?.Title
                          ))
                        : `Invoice #${selectedEvent?.InvoiceNumber}`
                      : ""}
                  </div>
                </Grid>
                {/* Customer Name */}
                <Grid size={12}>
                  <div
                    style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                  >
                    Customer Name
                  </div>
                  <div style={{ color: sched.bodyText, fontSize: 15 }}>
                    {selectedEvent?.FirstName && selectedEvent?.LastName
                      ? `${selectedEvent.FirstName} ${selectedEvent.LastName}`
                      : selectedEvent?.FirstName
                      ? selectedEvent.FirstName
                      : "N/A"}
                  </div>
                </Grid>

                {/* Status - for Visit, Contract, Invoice, Quote (Jobber pills — same as MuiTable) */}
                {(selectedEvent?.VisitId ||
                  selectedEvent?.ContractId ||
                  selectedEvent?.InvoiceId ||
                  selectedEvent?.QuoteId) && (
                  <Grid size={12}>
                    <div
                      style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                    >
                      Status
                    </div>
                    <Box className="schedule-event-status-value" sx={{ mt: 0.5 }}>
                      <JobberStatusBadge
                        tone={
                          selectedEvent?.VisitId
                            ? getVisitAppointmentStatusTone(selectedEvent?.Status)
                            : selectedEvent?.ContractId
                              ? getCustomerContractListStatusTone(selectedEvent?.Status)
                              : getJobberStatusTone(selectedEvent?.Status)
                        }
                      >
                        {selectedEvent?.Status || "N/A"}
                      </JobberStatusBadge>
                    </Box>
                  </Grid>
                )}

                {/* Start Date - for Visit, Contract */}
                {(selectedEvent?.VisitId || selectedEvent?.ContractId) && selectedEvent?.start && (
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6
                    }}>
                    <div
                      style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                    >
                      Start Date
                    </div>
                    <div style={{ color: sched.bodyText, fontSize: 15 }}>
                      {formatDateWithUserTimezone(selectedEvent.start, {
                          dateFormat: dateFormat || "MM/DD/YYYY",
                          includeSeconds: false,
                          excludeTime: true,
                        })}
                    </div>
                  </Grid>
                )}

                {/* End Date / Completion Date - for Contract */}
                {selectedEvent?.ContractId && (
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6
                    }}>
                    <div
                      style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                    >
                      {selectedEvent?.CompletionDate ? "Completion Date" : "End Date"}
                    </div>
                    <div style={{ color: sched.bodyText, fontSize: 15 }}>
                      {selectedEvent?.CompletionDate
                        ? formatDateWithUserTimezone(selectedEvent.CompletionDate, {
                            dateFormat: dateFormat || "MM/DD/YYYY",
                            includeSeconds: false,
                            excludeTime: true,
                          })
                        : selectedEvent?.end
                        ? formatDateWithUserTimezone(moment(selectedEvent.end).subtract(1, 'day').toISOString(), {
                            dateFormat: dateFormat || "MM/DD/YYYY",
                            includeSeconds: false,
                            excludeTime: true,
                          })
                        : selectedEvent?.OneoffJob?.EndDate
                        ? formatDateWithUserTimezone(selectedEvent.OneoffJob.EndDate, {
                            dateFormat: dateFormat || "MM/DD/YYYY",
                            includeSeconds: false,
                            excludeTime: true,
                          })
                        : "N/A"}
                    </div>
                  </Grid>
                )}

                {/* Schedule Date - for Quote, Invoice */}
                {(selectedEvent?.QuoteId || selectedEvent?.InvoiceId) && selectedEvent?.start && (
                  <Grid size={12}>
                    <div
                      style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                    >
                      Schedule Date
                    </div>
                    <div style={{ color: sched.bodyText, fontSize: 15 }}>
                      {formatDateWithUserTimezone(selectedEvent.start, {
                          dateFormat: dateFormat || "MM/DD/YYYY",
                          includeSeconds: false,
                          excludeTime: true,
                        })}
                    </div>
                  </Grid>
                )}

                {/* Note - for Visit */}
                {selectedEvent?.VisitId && selectedEvent?.Note && (
                  <Grid size={12}>
                    <div
                      style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                    >
                      Note
                    </div>
                    <div style={{ color: sched.bodyText, fontSize: 15 }}>
                      {selectedEvent.Note}
                    </div>
                  </Grid>
                )}

                {/* Visit status — chips (clearer than split labels) */}
                {selectedEvent?.VisitId && (
                  <>
                    <Grid
                      size={{
                        xs: 12,
                        sm: 6
                      }}>
                      <div
                        style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                      >
                        Confirmed
                      </div>
                      <div style={{ color: sched.bodyText, fontSize: 15 }}>
                        {selectedEvent?.IsConfirm || selectedEvent?.IsConfirmByWorker ? "Yes" : "No"}
                      </div>
                    </Grid>
                    <Grid
                      size={{
                        xs: 12,
                        sm: 6
                      }}>
                      <div
                        style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                      >
                        Completed
                      </div>
                      <div style={{ color: sched.bodyText, fontSize: 15 }}>
                        {selectedEvent?.IsComplete ? "Yes" : "No"}
                      </div>
                    </Grid>
                  </>
                )}

                {/* Created By - Only for Customer Events */}
                {selectedEvent?.EventId && (
                  <Grid size={12}>
                    <div
                      style={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                    >
                      Created By
                    </div>
                    <div style={{ color: sched.bodyText, fontSize: 15 }}>
                      {selectedEvent?.CreatedBy || "Unknown"}
                    </div>
                  </Grid>
                )}

                
                {selectedEvent?.EventId && (
                  <>
                    {selectedEvent?.PhoneNumber && (
                      <Grid
                        size={{
                          xs: 12,
                          sm: 6
                        }}>
                        <div
                          style={{
                            color: sched.label,
                            fontWeight: 600,
                            fontSize: 15,
                          }}
                        >
                          Phone Number
                        </div>
                        <div style={{ color: sched.bodyText, fontSize: 15 }}>
                          {formatUSPhone(selectedEvent.PhoneNumber)}
                        </div>
                      </Grid>
                    )}

                    {selectedEvent?.EmailAddress && (
                      <Grid
                        size={{
                          xs: 12,
                          sm: 6
                        }}>
                        <div
                          style={{
                            color: sched.label,
                            fontWeight: 600,
                            fontSize: 15,
                          }}
                        >
                          Email Address
                        </div>
                        <div style={{ color: sched.bodyText, fontSize: 15 }}>
                          {selectedEvent.EmailAddress}
                        </div>
                      </Grid>
                    )}

                    {selectedEvent?.Tags && selectedEvent.Tags.length > 0 && (
                      <Grid size={12}>
                        <div
                          style={{
                            color: sched.label,
                            fontWeight: 600,
                            fontSize: 15,
                          }}
                        >
                          Tags
                        </div>
                        <div style={{ color: sched.bodyText, fontSize: 15 }}>
                          {selectedEvent.Tags.map((tag, index) => (
                            <span
                              key={index}
                              style={{
                                marginRight: "4px",
                                padding: "2px 6px",
                                backgroundColor: sched.tagBg,
                                color: sched.tagFg,
                                borderRadius: "3px",
                                fontSize: "12px",
                              }}
                            >
                              #{tag}
                            </span>
                          ))}
                        </div>
                      </Grid>
                    )}

                    {selectedEvent?.Attachments &&
                      selectedEvent.Attachments.length > 0 && (
                        <Grid size={12}>
                          <div
                            style={{
                              color: sched.label,
                              fontWeight: 600,
                              fontSize: 15,
                            }}
                          >
                            Attachments
                          </div>
                          <div style={{ color: sched.bodyText, fontSize: 15 }}>
                            {selectedEvent.Attachments.map(
                              (attachment, index) => (
                                <div key={index} style={{ marginBottom: "4px" }}>
                                  📎{" "}
                                  {attachment.name ||
                                    attachment.filename ||
                                    `Attachment ${index + 1}`}
                                </div>
                              )
                            )}
                          </div>
                        </Grid>
                      )}
                  </>
                )}
              </Grid>
            </div>
            <Box className="schedule-event-location-block" sx={{ mt: 0.5 }}>
              <Typography
                sx={{
                  fontSize: "0.6875rem",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  color: sched.label,
                  mb: 1,
                  px: 0.25,
                  borderLeft: "4px solid #e88c44",
                  pl: 1.5,
                }}
              >
                Location
              </Typography>
              <Paper
                elevation={0}
                sx={{
                  border: `1px solid ${sched.msgBorder}`,
                  borderRadius: "10px",
                  bgcolor: sched.msgPaper,
                  px: { xs: 1.5, sm: 2 },
                  py: { xs: 1.25, sm: 1.5 },
                  boxShadow: "var(--shadow-sm)",
                }}
              >
                <Typography
                  component="div"
                  sx={{ color: sched.bodyText, fontSize: "0.9375rem", fontWeight: 500, lineHeight: 1.5 }}
                >
                  {selectedEvent
                    ? `${
                        selectedEvent?.Address ? `${selectedEvent?.Address}, ` : ""
                      }${selectedEvent?.City || "-"}, ${selectedEvent?.State || "-"} ${
                        selectedEvent?.Zip || "-"
                      }`
                    : ""}
                </Typography>
              </Paper>
            </Box>
          </DialogContent>
          <Divider
            style={{
              width: "100%",
              marginBottom: "5px",
              backgroundColor: sched.divider,
            }}
          />
          <DialogActions
            sx={{
              flexShrink: 0,
              padding: { xs: "12px 16px", sm: "12px 20px" },
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: "12px", sm: "0" },
              bgcolor: "var(--bg-main)",
              borderTop: "1px solid var(--border)",
            }}
            className="schedule-event-dialog-actions"
          >
            <Grid container spacing={{ xs: 0, sm: 0 }} justifyContent={{ xs: "stretch", sm: "space-between" }} alignItems="center" sx={{ width: "100%" }}>
              <Grid
                sx={{ width: { xs: "100%", sm: "auto" } }}
                size={{
                  xs: 12,
                  sm: "auto"
                }}>
                {!(selectedEvent?.EventId && isEditingMessage) && (
                  <Box sx={{ width: { xs: "100%", sm: "auto" }, "& button": { width: { xs: "100%", sm: "auto" } } }}>
                  <WhiteButton
                    onClick={handleClose}
                    label="Cancel"
                    style={{
                      borderRadius: "5px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  />
                  </Box>
                )}
              </Grid>
              <Grid
                sx={{ width: { xs: "100%", sm: "auto" } }}
                size={{
                  xs: 12,
                  sm: "auto"
                }}>
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: { xs: "12px", sm: "8px" }, width: { xs: "100%", sm: "auto" } }}>
                  {!selectedEvent?.VisitId && !selectedEvent?.EventId && (
                    <Box sx={{ width: { xs: "100%", sm: "auto" }, "& button": { width: { xs: "100%", sm: "auto" } } }}>
                      <BlueButton
                        onClick={() => {
                          const id =
                            selectedEvent?.QuoteId ||
                            selectedEvent?.ContractId ||
                            selectedEvent?.InvoiceId;
                          const navigateTo = selectedEvent?.QuoteId
                            ? `/${CompanyUrl}/add-quotes`
                            : selectedEvent?.ContractId
                            ? `/${CompanyUrl}/add-contract`
                            : `/${CompanyUrl}/addinvoice`;

                          navigate(navigateTo, {
                            state: {
                              ...(selectedEvent?.InvoiceId ? {} : { id: id }),
                              invoiceId: selectedEvent?.InvoiceId,
                              navigats: [
                                ...(location?.state?.navigats || []),
                                navigateTo,
                              ],
                            },
                          });
                        }}
                        label={
                          <>
                            <EditIcon
                              color="#ffffff"
                              style={{
                                marginRight: "8px",
                                fontSize: "0.875rem",
                              }}
                            />
                            Edit
                          </>
                        }
                        style={{
                          color: "#fff",
                          backgroundColor: "var(--navy-deep)",
                          borderRadius: "5px",
                          padding: "8px 16px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      />
                    </Box>
                  )}
                  {selectedEvent?.EventId && !isEditingMessage && (
                    <>
                      <Box sx={{ width: { xs: "100%", sm: "auto" }, "& button": { width: { xs: "100%", sm: "auto" } } }}>
                        <WhiteButton
                          onClick={handleEditMessage}
                          label="Edit Event"
                          style={{
                            borderRadius: "5px",
                            padding: "8px 16px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        />
                      </Box>
                      <Box sx={{ width: { xs: "100%", sm: "auto" }, "& button": { width: { xs: "100%", sm: "auto" } } }}>
                        <WhiteButton
                          onClick={handleDeleteMessage}
                          label={isDeletingMessage ? "Deleting..." : "Delete Event"}
                          disabled={isDeletingMessage}
                          style={{
                            borderRadius: "5px",
                            padding: "8px 16px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        />
                      </Box>
                    </>
                  )}
                  {selectedEvent?.EventId && isEditingMessage && (
                    <>
                      <Box sx={{ width: { xs: "100%", sm: "auto" }, "& button": { width: { xs: "100%", sm: "auto" } } }}>
                        <WhiteButton
                          onClick={handleCancelEdit}
                          label="Cancel"
                          style={{
                            borderRadius: "5px",
                            padding: "8px 16px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        />
                      </Box>
                      <Box sx={{ width: { xs: "100%", sm: "auto" }, "& button": { width: { xs: "100%", sm: "auto" } } }}>
                        <BlueButton
                          onClick={handleUpdateCustomerMessage}
                          label={isUpdatingMessage ? "Editing..." : "Edit"}
                          disabled={isUpdatingMessage}
                          style={{
                            color: "#fff",
                            backgroundColor: isUpdatingMessage ? "#ccc" : sched.primaryBtn,
                            borderRadius: "5px",
                            padding: "8px 16px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            opacity: isUpdatingMessage ? 0.7 : 1,
                            cursor: isUpdatingMessage ? "not-allowed" : "pointer",
                          }}
                        />
                      </Box>
                    </>
                  )}
                  {!selectedEvent?.EventId && (
                    <Box sx={{ width: { xs: "100%", sm: "auto" }, "& button": { width: { xs: "100%", sm: "auto" } } }}>
                      <BlueButton
                        onClick={() => {
                          const id =
                            selectedEvent?.VisitContractId ||
                            selectedEvent?.QuoteId ||
                            selectedEvent?.ContractId ||
                            selectedEvent?.InvoiceId;

                      const navigateTo = selectedEvent?.VisitContractId
                        ? `/${CompanyUrl}/contract-details`
                        : selectedEvent?.QuoteId
                        ? `/${CompanyUrl}/quotes-detail`
                        : selectedEvent?.ContractId
                        ? `/${CompanyUrl}/contract-details`
                        : selectedEvent?.InvoiceId
                        ? `/${CompanyUrl}/invoice-details`
                        : "";

                          navigate(navigateTo, {
                            state: {
                              id: id,
                              navigats: [
                                ...(location.state?.navigats || []),
                                navigateTo,
                              ],
                            },
                          });
                        }}
                        label="View Details"
                        style={{
                          color: "#fff",
                          backgroundColor: sched.primaryBtn,
                          borderRadius: "5px",
                          padding: "8px 16px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <Dialog
          open={customerMessageOpen}
          onClose={handleCustomerMessageClose}
          fullWidth
          maxWidth="md"
          PaperProps={{
            style: {
              borderRadius: "16px",
              boxShadow: "var(--shadow-xl)",
            },
          }}
        >
          <DialogTitle
            sx={{
              m: 0,
              px: { xs: 2.5, sm: 3 },
              pt: { xs: 2, sm: 2.5 },
              pb: 1.75,
              background: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 1.5,
            }}
          >
            <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>
              <Typography
                component="div"
                sx={{
                  fontSize: { xs: "1.0625rem", sm: "1.125rem" },
                  fontWeight: 600,
                  color: "#0f172a",
                  lineHeight: 1.3,
                  letterSpacing: "-0.01em",
                }}
              >
                Customer Event
              </Typography>
              {selectedCustomer && (
                <Typography
                  component="div"
                  sx={{
                    mt: 0.25,
                    fontSize: { xs: "0.8125rem", sm: "0.875rem" },
                    fontWeight: 400,
                    color: "#64748b",
                    lineHeight: 1.4,
                  }}
                >
                  {[selectedCustomer?.FirstName, selectedCustomer?.LastName]
                    .filter(Boolean)
                    .join(" ")
                    .trim()}
                </Typography>
              )}
            </Box>
            <IconButton
              type="button"
              onClick={handleCustomerMessageClose}
              aria-label="Close dialog"
              size="small"
              sx={{
                flexShrink: 0,
                mt: -0.25,
                color: "#64748b",
                borderRadius: "8px",
                "&:hover": { bgcolor: "#f1f5f9", color: "#0f172a" },
              }}
            >
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent
            sx={{
              background: sched.bodyBg,
              color: sched.bodyText,
              padding: 0,
            }}
          >
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                className="text-blue-color"
                value={tabValue}
                onChange={handleTabChange}
                aria-label="customer message tabs"
                sx={{
                  "& .MuiTab-root": {
                    fontWeight: 600,
                    textTransform: "none",
                    fontSize: "16px",
                    color: sched.muted,
                  },
                  "& .Mui-selected": {
                    color: sched.tabSel,
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: sched.tabSel,
                  },
                }}
              >
                  <Tab label="Customer Event" />
              </Tabs>
            </Box>

            <Box sx={{ padding: "24px" }}>
              {selectedCustomer &&
                (() => {
                  return null;
                })()}
              {selectedCustomer && (
                <Box sx={{ marginBottom: "20px" }}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: sched.label,
                      fontWeight: 700,
                      fontSize: 18,
                      borderLeft: "4px solid var(--amber)",
                      paddingLeft: 2,
                      marginBottom: 2,
                    }}
                  >
                    Customer Details
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <Typography
                        sx={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                      >
                        Name
                      </Typography>
                      <Typography sx={{ color: sched.bodyText, fontSize: 15 }}>
                        {(() => {
                          const firstName = selectedCustomer.FirstName || "No First Name";
                          const lastName = selectedCustomer.LastName || "No Last Name";
                          return `${firstName} ${lastName}`.trim();
                        })()}
                      </Typography>
                    </Grid>
                    {(selectedCustomer.selectedLocation ||
                      (selectedCustomer.locationDetails &&
                        selectedCustomer.locationDetails.length > 0)) && (
                      <Grid size={12}>
                        <Typography
                          sx={{ color: sched.label, fontWeight: 600, fontSize: 15 }}
                        >
                          Address
                        </Typography>
                        <Typography sx={{ color: sched.bodyText, fontSize: 15 }}>
                          {(() => {
                            const locationToShow =
                              selectedCustomer.selectedLocation ||
                              selectedCustomer.locationDetails[0];

                            if (locationToShow) {
                              return `${locationToShow.Address || ""}, ${
                                locationToShow.City || ""
                              } ${locationToShow.State || ""} ${
                                locationToShow.Zip || ""
                              }`;
                            }
                            return "No address information available";
                          })()}
                        </Typography>
                      </Grid>
                    )}
                    {!selectedCustomer.selectedLocation &&
                      (!selectedCustomer.locationDetails ||
                        selectedCustomer.locationDetails.length === 0) && (
                        <Grid size={12}>
                          <Typography
                            sx={{
                              color: sched.label,
                              fontWeight: 600,
                              fontSize: 15,
                            }}
                          >
                            Address
                          </Typography>
                          <Typography sx={{ color: sched.bodyText, fontSize: 15 }}>
                            No address information available
                          </Typography>
                        </Grid>
                      )}
                  </Grid>
                  <Divider sx={{ margin: "16px 0" }} />
                </Box>
              )}

              {tabValue === 0 && (
                <InputText
                  fullWidth
                  multiline
                  rows={6}
                  value={customerMessage}
                  onChange={handleMessageChange}
                  placeholder="Enter your message description here..."
                  error={!!messageError}
                  helperText={messageError}
                  inputProps={{
                    maxLength: 500,
                  }}
                  ariaLabel="Customer event message"
                />
              )}

              {tabValue === 1 && (
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: sched.label,
                      fontWeight: 700,
                      fontSize: 18,
                      borderLeft: "4px solid var(--amber)",
                      paddingLeft: 2,
                      marginBottom: 2,
                    }}
                  >
                    Messages for{" "}
                    {selectedDate
                      ? formatDateWithUserTimezone(selectedDate, {
                          dateFormat: dateFormat || "MM/DD/YYYY",
                          includeSeconds: false
                        })
                      : ""}
                  </Typography>

                  {isLoadingMessages ? (
                    <Stack spacing={1.25} sx={{ py: 2, px: 1 }}>
                      {[1, 2, 3].map((k) => (
                        <Skeleton key={k} variant="rounded" height={72} animation="wave" />
                      ))}
                    </Stack>
                  ) : existingMessages.length > 0 ? (
                    <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
                      {existingMessages.map((message, index) => (
                        <Paper
                          key={message.EventId || index}
                          sx={{
                            padding: 2,
                            marginBottom: 2,
                            border: `1px solid ${sched.msgBorder}`,
                            borderRadius: 2,
                            backgroundColor: sched.msgPaper,
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid size={12}>
                              <Typography
                                sx={{
                                  color: sched.label,
                                  fontWeight: 600,
                                  fontSize: 14,
                                  marginBottom: 1,
                                }}
                              >
                                Message
                              </Typography>
                              <Typography
                                sx={{
                                  color: sched.bodyText,
                                  fontSize: 14,
                                  marginBottom: 2,
                                }}
                              >
                                {message.Message}
                              </Typography>
                            </Grid>
                            <Grid size={6}>
                              <Typography
                                sx={{
                                  color: sched.label,
                                  fontWeight: 600,
                                  fontSize: 12,
                                }}
                              >
                                Created By
                              </Typography>
                              <Typography sx={{ color: sched.muted, fontSize: 12 }}>
                                {message.CreatedBy} ({message.CreatedByUserRole})
                              </Typography>
                            </Grid>
                            <Grid size={6}>
                              <Typography
                                sx={{
                                  color: sched.label,
                                  fontWeight: 600,
                                  fontSize: 12,
                                }}
                              >
                                Created At
                              </Typography>
                              <Typography sx={{ color: sched.muted, fontSize: 12 }}>
                                {formatDateWithUserTimezone(message.Timestamp, {
                                  dateFormat: dateFormat || "MM/DD/YYYY",
                                  timeFormat: "12h",
                                  includeSeconds: false
                                })}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Paper>
                      ))}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        textAlign: "center",
                        padding: 4,
                        color: sched.muted,
                      }}
                    >
                      <Typography variant="body1">
                        No messages found for this date.
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </DialogContent>

          <Divider
            style={{
              width: "100%",
              marginBottom: "5px",
              backgroundColor: sched.divider,
            }}
          />

          <DialogActions sx={{ padding: "16px" }}>
            <Grid container justifyContent="space-between">
              <Grid>
                <WhiteButton
                  onClick={handleCustomerMessageClose}
                  label="Cancel"
                  style={{
                    borderRadius: "5px",
                    padding: "8px 16px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                  }}
                />
              </Grid>
              <Grid>
                {tabValue === 0 && (
                  <BlueButton
                    onClick={handleSaveCustomerMessage}
                    label={isSavingMessage ? "Saving..." : "Save"}
                    disabled={isSavingMessage}
                    style={{
                      color: "#fff",
                      backgroundColor: isSavingMessage ? "#ccc" : sched.primaryBtn,
                      borderRadius: "5px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      opacity: isSavingMessage ? 0.7 : 1,
                      cursor: isSavingMessage ? "not-allowed" : "pointer",
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <CustomerModal
          isCustomer={isCustomerModalOpen}
          setIsCustomer={(value) => {
            setIsCustomerModalOpen(value);
            if (!value) {
              setFormikValues({ CustomerId: "", LocationId: "" });
            }
          }}
          isProperty={isPropertyModalOpen}
          setIsProperty={setIsPropertyModalOpen}
          setFieldValue={(field, value) => {
            const newValues = { ...formikValues, [field]: value };
            setTimeStamp(value);
            setFormikValues(newValues);

            if (field === "CustomerId" && value) {
              fetchSelectedCustomer(value);
            }

            if (
              field === "LocationId" &&
              newValues.CustomerId &&
              newValues.LocationId
            ) {
              const selectedCustomerData = customerData.find(
                (customer) => customer.UserId === newValues.CustomerId
              );
              if (selectedCustomerData && selectedCustomerData.locationDetails) {
                const selectedLocation =
                  selectedCustomerData.locationDetails.find(
                    (loc) => loc.LocationId === newValues.LocationId
                  );
                if (selectedLocation) {
                  handleLocationSelection(selectedCustomerData, selectedLocation);
                }
              } else {
                console.error("Customer data not found or no locationDetails");
                console.error("selectedCustomerData:", selectedCustomerData);
              }
            }
          }}
          values={formikValues}
          lineItems={[]}
          setPropertyData={() => {}}
          setCustomersData={(customerData) => {
            if (customerData) {
              handleCustomerSelection(customerData);
            } else {
            }
          }}
          formik={{ values: formikValues }}
          source="Schedule"
          tokenDecode={null}
        />
      </Grid>
    </>
  );
};

export default CustomEvent;
